/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
class GoogleSearchEngine {
    getSearchUrl(query, options) {
        const searchParams = new URLSearchParams({
            q: `${options.excludeDomains && options.excludeDomains.length > 0 ? `${options.excludeDomains.map((domain)=>`-site:${domain}`).join(' ')} ` : ''}${query}`,
            num: `${options.count || 10}`
        });
        searchParams.set('udm', '14');
        return `https://www.google.com/search?${searchParams.toString()}`;
    }
    extractSearchResults(window) {
        const links = [];
        const document = window.document;
        const isValidUrl = (url)=>{
            try {
                new URL(url);
                return true;
            } catch (error) {
                return false;
            }
        };
        const extractSnippet = (element)=>{
            const clone = element.cloneNode(true);
            const titleElements = clone.querySelectorAll('h3');
            titleElements.forEach((el)=>el.remove());
            const citeElements = clone.querySelectorAll('cite');
            citeElements.forEach((el)=>el.remove());
            const scriptElements = clone.querySelectorAll("script, style");
            scriptElements.forEach((el)=>el.remove());
            const text = Array.from(clone.querySelectorAll('*')).filter((node)=>{
                var _node_textContent;
                return null === (_node_textContent = node.textContent) || void 0 === _node_textContent ? void 0 : _node_textContent.trim();
            }).map((node)=>{
                var _node_textContent;
                return null === (_node_textContent = node.textContent) || void 0 === _node_textContent ? void 0 : _node_textContent.trim();
            }).filter(Boolean).reduce((acc, curr)=>{
                if (!acc.some((text)=>text.includes(curr) || curr.includes(text))) acc.push(curr);
                return acc;
            }, []).join(' ').trim().replace(/\s+/g, ' ');
            return text;
        };
        try {
            const elements = document.querySelectorAll('.tF2Cxc');
            elements.forEach((element)=>{
                const titleEl = element.querySelector('h3');
                const urlEl = element.querySelector('a');
                const url = null == urlEl ? void 0 : urlEl.getAttribute('href');
                const snippet = extractSnippet(element.parentElement || element);
                if (!url || !isValidUrl(url)) return;
                const item = {
                    title: (null == titleEl ? void 0 : titleEl.textContent) || '',
                    url,
                    snippet,
                    content: ''
                };
                if (!item.title || !item.url) return;
                links.push(item);
            });
        } catch (error) {
            console.error(error);
        }
        return links;
    }
    async waitForSearchResults(page) {
        await page.waitForSelector('#search');
    }
}
export { GoogleSearchEngine };

//# sourceMappingURL=google-engine.mjs.map